﻿(function ($) {

    // NOTE: This won't work properly on elements not part of the top-level DOM or nested within other scrolling elements.        
    // TODO: Clip scrollbar to display to visible area on the element being displayed.    

    function updateAllFloatingScrollbars() {
        window.SolovisHorzScrollManagerCollection.updateAllFloatingScrollbars();
    }

    function delayedUpdateAllFloatingScrollbars() {
        setTimeout(
            updateAllFloatingScrollbars,
            1);
    };

    window.SolovisHorzScrollManagerCollection = {
        allScrollManagers: [],
        _globalEventsRegistered: false,

        addHorzScrollManager: function (manager) {
            this.allScrollManagers.push(manager);

            if (!this._globalEventsRegistered) {
                this._globalEventsRegistered = true;
                this._registerGlobalEvents();
            }
        },

        removeHorzScrollManager: function (manager) {
            this.allScrollManagers = _.reject(this.allScrollManagers, function (item) { return item === manager; });

            if (_.isEmpty(this.allScrollManagers) && this._globalEventsRegistered) {
                this._globalEventsRegistered = false;
                this._unregisterGlobalEvents();
            }

            manager.destroy();
        },

        removeHorzScrollManagerForElement: function (element) {
            var managerForElement = _.find(this.allScrollManagers, function (m) { return m.element === element; });
            if (managerForElement) {
                this.removeHorzScrollManager(managerForElement);
            }
        },

        updateAllFloatingScrollbars: function () {
            var self = this;
            var scrollManagersToRemove = [];

            // updateAllFloatingScrollbars needs to be called whenever the viewport is resized, scrolled, or new scroll managers are added.
            $(this.allScrollManagers).each(function (i, scrollManager) {
                try {
                    if ($app.UI.DomHelper.isDescendantOf(scrollManager.element, document.body)) {
                        let style = scrollManager.element.style;
                        if (style && style.display !== "none") {
                            scrollManager.updateVisibilityAndPosition();
                        }
                    }
                    else {
                        // The element is no longer part of the DOM, so remove the scroll manager.
                        scrollManagersToRemove.push(scrollManager);
                    }
                }
                catch (ex) {
                    console.log("Error updating floating scrollbar:");
                    console.log(ex);
                }
            });

            $(scrollManagersToRemove).each(function (i, scrollManager) {
                try {
                    self.removeHorzScrollManager(scrollManager);
                }
                catch (ex) {
                    console.log("Error removing scroll manager");
                    console.log(ex);
                }
            });
        },

        _registerGlobalEvents: function () {
            $(window).bind("resize", delayedUpdateAllFloatingScrollbars);
            $(window).bind("scroll", updateAllFloatingScrollbars);
        },

        _unregisterGlobalEvents: function () {
            $(window).unbind("resize", delayedUpdateAllFloatingScrollbars);
            $(window).unbind("scroll", updateAllFloatingScrollbars);
        }
    };


    var HorzScrollManager = function (element) {
        // Create the floating scrollbar.
        var scrollContainer = $('<div id="solovis-floating-hscroll"><div/></div>');
        var scrollInner = scrollContainer.children();

        scrollContainer.appendTo(document.body);

        // Initialize the floating scrollbar.
        scrollContainer
            .hide()
            .css({
                position: 'fixed',
                top: 0,
                left: 0,
                height: '30px',
                overflowX: 'auto',
                overflowY: 'hidden'
            })
            .scroll(function () {
                try {
                    // Scroll the element to desired position.
                    $(element).scrollLeft(scrollContainer.scrollLeft());
                }
                catch (ex) {
                    console.log("floating scroll error");
                    console.log(ex);
                }
            });

        scrollInner.css({
            border: '1px solid #fff',
            opacity: 0.01
        });

        this.element = element;
        this.scrollContainer = scrollContainer;
        this.scrollInner = scrollInner;
    };

    HorzScrollManager.prototype.destroy = function () {
        this.scrollContainer.remove();
    };

    HorzScrollManager.prototype.toggleFloatingScrollbar = function (state) {
        this.scrollContainer.toggle(!!state);
    };

    HorzScrollManager.prototype.syncToScrollOffsetFromElement = function () {
        var scrollLeft = this.element.scrollLeft();
        this.scrollContainer.scrollLeft(scrollLeft);
    };

    HorzScrollManager.prototype.checkIfHbarNeededBasedOnVerticalScrolling = function () {
        // Determine if horizontal scrollbar is needed because of vertical positioning.
        var wnd = $(window);

        var jElement = $(this.element);
        var top = jElement.offset().top;
        var bottom = top + jElement.height();
        var wndHeight = wnd.height();
        var viewportBottom = wnd.scrollTop() + wnd.height();
        var topOffset = 30;

        var needsHbar = false;
        if (top + topOffset < viewportBottom && bottom > viewportBottom) {
            needsHbar = true;
            this._topToUse = wndHeight - topOffset;
        }

        return needsHbar;
    };

    HorzScrollManager.prototype.checkIfHbarNeededDueToWidth = function () {
        // Determine if horizontal scrollbar is needed because of content width.
        var element = this.element;
        var jElement = $(element);

        var scrollLeft = jElement.scrollLeft();
        var scrollMax = element.scrollWidth - element.clientWidth;
        var widthOuter = jElement.innerWidth();
        var widthInner = widthOuter + scrollMax;

        if (widthInner > widthOuter) {
            this._scrollContainerWidthToUse = widthInner;
            return true;
        }
        else {
            return false;
        }

        this._widthInner
    };

    HorzScrollManager.prototype.updateVisibilityAndPosition = function () {
        if (this.checkIfHbarNeededBasedOnVerticalScrolling() &&
            this.checkIfHbarNeededDueToWidth()) {
            this.toggleFloatingScrollbar(true);
            this.setPositionToBottomOfView();
        }
        else {
            this.toggleFloatingScrollbar(false);
        }
    };

    HorzScrollManager.prototype.setPositionToBottomOfView = function () {
        var wnd = $(window);

        var element = this.element;
        var jElement = $(element);

        var scrollLeft = jElement.scrollLeft();
        var widthOuter = jElement.innerWidth();

        var screenLeft = jElement.offset().left - wnd.scrollLeft();

        // Update floating scrollbar's position and size.
        this.scrollContainer
            .css({
                left: screenLeft,
                top: this._topToUse,
                width: widthOuter
            })
            .scrollLeft(scrollLeft);

        this.scrollInner.width(this._scrollContainerWidthToUse);
    };


    // Enable floating scrollbar on an element. Use false for state to remove floating scrollbar.
    $.fn.solovisFloatingHScroll = function (state) {
        if (state === false) {
            $(this).each(function (i, element) {
                window.SolovisHorzScrollManagerCollection.removeHorzScrollManagerForElement(element);
            });
        }
        else if (this.length) {
            $(this).each(function (i, element) {
                var horzScrollManager = new HorzScrollManager(element);

                window.SolovisHorzScrollManagerCollection.addHorzScrollManager(horzScrollManager);
            });
        }

        updateAllFloatingScrollbars();

        // Required by jQuery for chaining.
        return this;
    };

})(jQuery);